import React, { Fragment } from 'react';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next/hooks';
// import { useSearchParams, useNavigate } from "react-router-dom";

import Button from '../../Button/Button';
import Loader from '../../Loader/Loader';
import InputEmoji2 from '../../Form/Input/InputEmoji2';

import { useStore } from '../../../hook-store/store';
import { getOriginalFileNameFromKey } from '../../../util/bucket/bucket-object-util';
// import { 
//   BASE_URL,
// } from '../../../App';

// import GroupInfoMembers from '../GroupInfo/GroupInfoMemberItem';

import { marks } from '../../../images/marks';
import classes from './GroupLoadParamBucketFile.module.css';


const GroupLoadParamContent = props => {
  const { 
    groupList,
    userId,
    paramFileSelectGroup,
    setParamFileSelectGroup,
    showLoadParamModalHandler,
    fileLoading,
    isSameUser,
    textInput,
    setTextInput,
    keyData,
  } = props;

  const [t] = useTranslation('translation');

  // let [searchParams, setSearchParams] = useSearchParams();

  const [store, dispatch] = useStore();
  const { groupImageUrls } = store;
  const { isAuth } = store.uiStore;
  const { groupParamFileData } = store.groupStore;


  const textInputHandler = (event) => {
    setTextInput(event.target.value);
  }

  
  const userJoinGroups = groupList.filter(group => {
    const isMember = group.allMemberUserIds.find(element => {
      return element.userId === userId;
    })

    return isMember;
  });

  // console.log(userJoinGroups)

  let groupLoadParamContentBody;
  
  const modalTitle = 'Create post with stored file in group';

  groupLoadParamContentBody = (
    <div>
        <div className={classes.groupLoadParamBucketFileTitle}>
          {modalTitle}
        </div>

        {keyData?.key && (
          <div>
            <div className={classes.groupLoadParamBucketFileSection}>
              <strong>
                <div>
                  When stored file is deleted, group user will loose access to the file from group.
                </div>
                <div>
                  Deletion of group post for file does not affect stored file.
                </div>
              </strong>
            </div>

            <div className={classes.groupLoadParamBucketFileSection}>
              <div className={classes.groupLoadParamBucketFileSecTitle}>
                File name
              </div>
              <div>
                {getOriginalFileNameFromKey(decodeURI(keyData.key))}
              </div>
            </div>
          </div>
        )}

        <div className={classes.groupLoadParamBucketFileSection}>
          <div className={classes.groupLoadParamBucketFileSecTitle}>
            Text for file
          </div>
          {/* <textarea className={classes.groupLoadParamBucketFileInput} 
            onChange={textInputHandler}
            /> */}
          <InputEmoji2 
            getInputHandler={setTextInput}
            nRows={3}
            emojiPickerStyle={{
              display: 'block',
              // width: "100%",
              maxWidth: "100%",
              paddingBottom: "2rem",
            }}
            // textAreaStyle={{width: "30%"}}
            inputValue={textInput}
          />
        </div>
        
        <div className={classes.groupLoadParamBucketFileSection}>
          <div className={classes.groupLoadParamBucketFileSecTitle}>
            Select group
          </div>
          <ul className={classes.groupLoadParamBucketFileList}>
            {userJoinGroups.map(group => {
              const groupImageUrlObj = groupImageUrls.find(element => {
                return element.groupRoomId === group.groupRoomId;
              })

              return (
                <li className={classes.groupLoadParamBucketFileListItem}
                  key={group.groupRoomId}
                >
                  <div className={classes.groupLoadParamBucketFileListRow}>
                    <div>
                      <div className={classes.groupLoadParamBucketFileListName} >
                        <span>
                          {group.groupName}
                        </span>
                        {groupImageUrlObj && (
                          <img className={classes.groupLoadParamBucketFileListNameImage}
                            // style={{width:"1.5rem", height:"1.5rem"}}
                            src={groupImageUrlObj.imageUrl}
                          />
                        )}
                      </div>
                      <div className={classes.groupLoadParamBucketFileListSubText}>
                        (Group ID: {group.groupRoomId})
                      </div>
                    </div>
                    <div>
                      <Button mode="raised" design="" type="submit" 
                        onClick={() => {
                          setParamFileSelectGroup(group);
                        }}
                      >
                        create
                      </Button>
                    </div>
                  </div>
                </li>
              )
            })}
          </ul>
        </div>
    </div>
  );

  if (fileLoading) {
    groupLoadParamContentBody = (
      <Loader />
    );
  }

  if (!isSameUser) {
    groupLoadParamContentBody = (
      <div>
        <div className={classes.groupLoadParamBucketFileTitle}>
          {modalTitle}
        </div>
        <div>
          Login user is diffrert. Please login with same account.
        </div>
        {/* <button
          onClick={showLoadParamModalHandler}
        >
          close
        </button> */}
      </div>
    );
  }

  if (!isAuth) {
    groupLoadParamContentBody = (
      <div>
        <div className={classes.groupLoadParamBucketFileTitle}>
          {modalTitle}
        </div>
        <div>Login is required to post file. Please login with same account.</div>
        {/* <button
          onClick={showLoadParamModalHandler}
        >
          close
        </button> */}
      </div>
    );
  }

  return (
    <Fragment>
      <div>{groupLoadParamContentBody}</div>
    </Fragment>

  );
}

export default GroupLoadParamContent;